import { Statuses } from '../types/status';

export function canShowSurveyorStatusBreakdown({
  canViewMultipleSurveyors,
  surveyorStatus,
}: {
  canViewMultipleSurveyors: boolean;
  surveyorStatus?: { [uid: string]: Statuses };
}) {
  return (
    canViewMultipleSurveyors && Object.keys(surveyorStatus || {}).length > 1
  );
}
